import { createTheme } from '@mui/material/styles';
import { acme } from './acmeTheme';

const fontFamily = acme.font.sans;

/** Global MUI theme — Inter everywhere in the app UI. */
export const muiTheme = createTheme({
  typography: {
    fontFamily,
    letterSpacing: '-0.022em',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: { fontWeight: 600, letterSpacing: '-0.045em' },
    h2: { fontWeight: 600, letterSpacing: '-0.038em' },
    h3: { fontWeight: 600, letterSpacing: '-0.038em' },
    h4: { fontWeight: 600, letterSpacing: '-0.035em' },
    h5: { fontWeight: 600, letterSpacing: '-0.03em' },
    h6: { fontWeight: 600, letterSpacing: '-0.028em' },
    subtitle1: { letterSpacing: '-0.022em' },
    subtitle2: { letterSpacing: '-0.02em' },
    body1: { letterSpacing: '-0.022em' },
    body2: { letterSpacing: '-0.02em' },
    button: { letterSpacing: '-0.015em', textTransform: 'none' },
    overline: { letterSpacing: '0.08em' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily,
          letterSpacing: '-0.022em',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
  },
});
